import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

export const StyledMegaMenuSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
}
`

const StyledTitle = styled.div`
  margin: 16px 16px 32px 16px;
  font-size: 20px;
  font-family: 'Exo';
  color: ${colors.secondary20};
`

const StyledContent = styled.div`
  display: flex;
  flex: 1;
  gap: 5px;
`

const MegaMenuSection = ({ title, children }) => {
  return (
    <StyledMegaMenuSection data-test='megamenu-section'>
      <StyledTitle>
        {title}
      </StyledTitle>

      <StyledContent>
        {children}
      </StyledContent>
    </StyledMegaMenuSection>
  )
}

MegaMenuSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export default MegaMenuSection
